module.exports = __webpack_public_path__ + "img/upload-icon.b5561541.svg";